module.exports = __webpack_public_path__ + "src/assets/img/text.9a4592c9.png";